import { Fragment, lazy } from 'react';
import { Route } from 'react-router-dom';

import { CHAPTER_READER_PATHS } from '@/utils/lesson/chapterReaderPaths';
import { LEGACY_LESSON_PATHS } from '@/utils/lesson/legacyLessonPaths';
import { LESSON_TAB_PATHS } from '@/utils/lesson/lessonTabs';

import LessonTabIndexRedirect from './LessonTabIndexRedirect';

const InstructionsTab = lazy(
  () => import('@/pages/lesson/tabs/InstructionsTab'),
);
const ResourcesTab = lazy(() => import('@/pages/lesson/tabs/ResourcesTab'));

const MaterialTab = lazy(() => import('@/pages/lesson/tabs/MaterialTab'));

const MaterialChapterRoute = lazy(
  () => import('@/pages/lesson/MaterialChapterRoute'),
);

const TeacherMaterialTab = lazy(
  () => import('@/pages/lesson/tabs/TeacherMaterialTab'),
);
const ChallengesTab = lazy(() => import('@/pages/lesson/tabs/ChallengesTab'));

const ActivitiesTab = lazy(() => import('@/pages/lesson/tabs/ActivitiesTab'));

const ActivityPageSwitcher = lazy(
  () => import('@/pages/activity/ActivityPageSwitcher'),
);

const ActivitySuccessPage = lazy(
  () => import('@/pages/activity/ActivitySuccessPage'),
);

type LessonRoutesParams = {
  basePath: string;
  lessonElement: JSX.Element;
  legacyElement: JSX.Element;
};

export default function lessonRoutes({
  basePath,
  lessonElement,
  legacyElement,
}: LessonRoutesParams) {
  return (
    <Fragment key={basePath}>
      <Route path={basePath} element={lessonElement}>
        <Route index element={<LessonTabIndexRedirect />} />
        <Route
          path={LESSON_TAB_PATHS.instruction}
          element={<InstructionsTab />}
        />
        <Route path={LESSON_TAB_PATHS.resources} element={<ResourcesTab />} />
        <Route path={LESSON_TAB_PATHS.material} element={<MaterialTab />} />
        {CHAPTER_READER_PATHS.map(path => (
          <Route key={path} path={path} element={<MaterialChapterRoute />} />
        ))}
        <Route
          path={LESSON_TAB_PATHS.teacherBook}
          element={<TeacherMaterialTab />}
        />
        <Route path={LESSON_TAB_PATHS.challenge} element={<ChallengesTab />} />
        <Route path={LESSON_TAB_PATHS.activity} element={<ActivitiesTab />} />
        {LEGACY_LESSON_PATHS.map(path => (
          <Route key={path} path={path} element={legacyElement} />
        ))}
      </Route>
      <Route
        path={`${basePath}/${LESSON_TAB_PATHS.activity}/:activityId`}
        element={<ActivityPageSwitcher />}
      />
      <Route
        path={`${basePath}/${LESSON_TAB_PATHS.activity}/:activityId/success`}
        element={<ActivitySuccessPage />}
      />
    </Fragment>
  );
}
